import React from "react";
import Sliderhome from "../Menhome/Sliderhome";
import Most from "../Menhome/Most";
import Rooms from "../Menhome/Rooms";
import Take from "../Menhome/Take";
import Painting from "../Menhome/Painting";
import Brand from "../Menhome/Brand";
import Servicios from "../Menhome/Services2";
import { Helmet } from "react-helmet-async";
import Reviews from "../Menhome/Reviews";

const Main = () => {
  return (
    <>
      <Helmet>
        <title>Hotel La Finca Zotoluca | Inicio</title>
        <meta
          name="description"
          content="A través de nuestra conexión con la Hacienda Zotoluca y la riqueza de la altiplanicie pulquera, nos posicionamos como un destino único que redefine la hospitalidad en Hidalgo."
        />
      </Helmet>
      <main>
        <Sliderhome />
        <Most />
        <Painting />
        <Servicios />
        <Take />
        <Rooms />
        <Reviews />
        <Brand />
      </main>
    </>
  );
};

export default Main;
